import React from "react";

interface GeneratingViewProps {
  steps: Array<{ label: string; state: "done" | "active" | "pending" }>;
}

const GeneratingView = ({ steps }: GeneratingViewProps) => (
  <section className="op-form-card op-generating" aria-live="polite">
    <h2 className="op-section-title">Generating Equipment Configuration...</h2>
    <ul className="op-progress-list">
      {steps.map((step) => (
        <li key={step.label} className={`op-progress-list__item op-progress-list__item--${step.state}`}>
          <span aria-hidden="true">{step.state === "done" ? "✓" : step.state === "active" ? "●" : "○"}</span>
          {step.label}
        </li>
      ))}
    </ul>
  </section>
);

export default GeneratingView;
